import styled from "styled-components";

const Wrapper = styled.div`
  padding: 80px 0;
  background-color: var(--bg-color);
  border: 1px solid transparent;
  /* border-top-color: var(--primary-color); Removed hard border line preference */
  overflow: hidden;

  .container {
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 60px;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    @media (max-width: 1020px) {
      grid-template-columns: 1fr;
      padding: 0 30px;
      grid-column-gap: 0;
    }
    @media (max-width: 760px) {
      grid-row-gap: 40px;
    }

    .left {
      /* height: 500px; let content dictate */
      display: flex;
      justify-content: center;

      .image {
        width: 100%;
        max-width: 500px;
        border-radius: var(--radius);
        box-shadow: var(--shadow-md);
      }

      @media (max-width: 1020px) {
        display: none;
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      text-align: left;
      /* margin-left: 50px; removed margin-left in favor of grid gap */
      gap: 30px;

      @media (max-width: 1020px) {
        margin-left: 0;
        grid-template-columns: 1fr;
        align-items: center;
      }

      h3 {
        color: var(--primary-color);
        font-family: 'Playfair Display', serif;
        font-size: 2.5rem;
        position: relative;
        padding-bottom: 15px;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 50px;
          height: 3px;
          background-color: var(--secondary-color);
        }

        @media (max-width: 600px) {
          font-size: 2rem;
        }
        @media (max-width: 1020px) {
          text-align: center;
          &::after { left: 50%; transform: translateX(-50%); }
        }
      }

      .colorfull {
        color: var(--secondary-color);
        font-style: italic;
      }
      ul {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 30px;
        grid-row-gap: 20px;
        width: 100%;

        @media (max-width: 600px) {
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 15px;
          grid-row-gap: 15px;
        }
        
        li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 1.15rem;
          font-weight: 500;
          color: #444;
          font-family: 'Lato', sans-serif;

          @media (max-width: 600px) {
            font-size: 0.95rem;
          }

          .check-icon {
            color: var(--secondary-color); /* Updated to Gold */
            font-size: 1.4rem;
            flex-shrink: 0;
          }
        }
      }
    }
  }
`;

export default Wrapper;
